// extracted by mini-css-extract-plugin
export default {"header":"_Header_header__H6e+i"};